import { produce } from 'immer';
import { AUTH_LOGOUT } from '../actions';
import { PERMISSION_SET } from '../actions/permissions';

const initialState = {
  activity: [],
  activity_scorm: [],
  course: [],
  event: [],
};

const permissionReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case AUTH_LOGOUT._SUCCESS: {
        draft = initialState;
        break;
      }

      case PERMISSION_SET: {
        const { data = {}, reset = false } = action;
        if (reset) draft = { ...data };
        else draft = { ...state, ...data };
        break;
      }
      default:
        return state;
    }
    return draft;
  });

export default permissionReducer;
